export default [
  'left',
  'right',
  'combined',
  'momentsLeft',
  'momentsRight',
  'xForceLeft',
  'xForceRight',
  'xMomentsLeft',
  'xMomentsRight',
  'yForceLeft',
  'yForceRight',
  'yMomentsLeft',
  'yMomentsRight',
];
